<nav aria-label="Main" class="dashboard-nav">
  <app-dashboard-nav-list [items]="dashboardItems" (itemClick)="itemClick.emit($event)" />
</nav>
